import * as React from 'react';
import { Check, ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export function MultiSelect({ options, selected, onChange, placeholder = '選択してください', testId, disabled = false }) {
  const [open, setOpen] = React.useState(false);

  const toggleOption = (option) => {
    if (selected.includes(option)) {
      onChange(selected.filter((s) => s !== option));
    } else {
      onChange([...selected, option]);
    }
  };

  return (
    <Popover open={open && !disabled} onOpenChange={(v) => !disabled && setOpen(v)}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          data-testid={testId}
          className="w-full justify-between border-zinc-300 font-normal disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span className="text-left truncate">
            {selected.length > 0 ? selected.join('、') : placeholder}
          </span>
          <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full p-0" align="start">
        <div className="max-h-60 overflow-auto">
          {options.map((option) => {
            const isSelected = selected.includes(option);
            return (
              <button
                key={option}
                type="button"
                onClick={() => toggleOption(option)}
                data-testid={`multi-select-option-${option}`}
                className={cn(
                  'flex w-full items-center px-3 py-2 text-sm hover:bg-zinc-100 transition-colors',
                  isSelected && 'bg-blue-50'
                )}
              >
                <div
                  className={cn(
                    'mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-zinc-400',
                    isSelected ? 'bg-teal-700 border-teal-700 text-white' : 'opacity-50'
                  )}
                >
                  {isSelected && <Check className="h-3 w-3" />}
                </div>
                <span>{option}</span>
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
